import React, { Component } from 'react'
import inputComponents from './inputs/inputComponents'
import { checkTextTranslation, checkTranslation, getObject, setObject, translate } from '../utils/useful'
import TableRow from './partials/TableRow';
import TableHead from './partials/TableHead';
import ReactDOM from 'react-dom'
import DraggableList from './dragLibrary/DraggableList';
import { getBoundingClientRect } from '../utils/functions';
import { detectBrowser } from '../utils/useful'
import Loader from 'react-loader-spinner'
import Modal from './Modal';
import ActionButton from './partials/ActionButton';
import Collapsible from 'react-collapsible';
import TableRowAbsolute from './partials/TableRowAbsolute';
import { nanoid } from 'nanoid';

class TableViewer extends Component {

    state = {
        // errors: {},
        data: [],
        group: null,
        // width: window.innerWidth,
        cellWidths: 0,
        show: false,
        grouped: true,
        collapses: {},
        tempWidth: {},
        selectedCell: {},
        '*childern': [],
    }

    headerIsScrolling = false
    scrollTrigger = null

    closeSelect = (event) => {
        if (!this.tableContainer?.contains(event.target) && this.state.selectedCell['*last']) {
            let last = this.state.selectedCell['*last']
            if (this.state.selectedCell[last.fullId]) {
                this.changeSelected(last.id, last.key, last.newData)
            }
            // this.setState({ selectedCell: {} })
            // this.props.clearTempValue()
        }
    }

    componentDidMount() {
        // let keys = ["values.SdlkDrq7qvqxYO7Jbedtp"]
        // setTimeout(() => {
        //     this.groupBy(0, this.props.data, keys)
        // }, 100)
        // console.log("componentDidMount")
        this.init()
        // window.addEventListener('resize', this.calcResize);
        document.addEventListener('click', this.closeSelect, true)
        this.setState({ broswer: detectBrowser(), })
    }

    componentDidUpdate(prevProps) {

        // console.log('this.props.view?.settings', this.props.view?.settings)
        // console.log('prevProps.view?.settings', prevProps.view?.settings)
        // if ((JSON.stringify(this.props.headers) !== JSON.stringify(prevProps.headers))) {
        //     this.init()
        //     // this.initData()
        // }
        // if ((this.props.data != prevProps.data)) {
        //     this.setState({ data: this.props.data })
        // }

        if (prevProps.width != this.props.width) {
            // let cellWidths = this.calcCellWidths()
            // this.setState({ cellWidths })
            this.calcResize()
        }
        // console.log('this.props.view',this.props.view)
        // console.log('prevProps.view?.id',prevProps.view?.id)
        if ((this.props.view?.id != prevProps.view?.id) || (JSON.stringify(this.props.view?.settings) != JSON.stringify(prevProps.view?.settings))) {
            // console.log('tpONCHANFE3')
            this.useViewSettings(() => {
                // console.log('tpOOl')
                this.useUserSettings()
            })
        }
        if ((JSON.stringify(this.props.view?.settings?.groupBy) != JSON.stringify(prevProps.view?.settings?.groupBy)) || (JSON.stringify(this.props.data) != JSON.stringify(prevProps.data)) || (JSON.stringify(this.props.headers) !== JSON.stringify(prevProps.headers))) {
            // this.initData()
            this.setState({ grouped: false })
            this.init()
        }
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.calcResize)
        // if (this.table) {
        //     this.table.removeEventListener('scroll', this.tableScroll);
        // }
    }

    init = () => {
        // console.log('*TAABLEINITD')
        if (Array.isArray(this.props.headers)) {
            let headers = this.prepareHeader()
            this.setState({ show: true, headers }, () => {
                // let cellWidths = this.calcCellWidths()
                // this.setState({ show: false }, () => {
                this.setState({ data: JSON?.parse(JSON?.stringify(this.props.data ?? [])), show: true }, () => {

                    // console.log('TAABLEINITD', this.state.data)
                    // this.useViewSettings(() => {
                    this.useUserSettings()
                    // })


                    this.setWidth()
                    this.initData()
                })
                // })
            })
        }
    }

    makeChildren = (data, index, pIndex, initData, cb) => {


        if (JSON.stringify(this.props.data) != JSON.stringify(initData)) {
            cb()
            return
        }
        if (data && data[index]) {
            if (data[pIndex]) {
                // let found
                // data[pIndex]?.parent?.map((element) => {
                //     if (element._id == data[index]._id) {
                //         found = true
                //     }
                // })


                if (data[pIndex]?.parent) {

                    let parentId = data[pIndex]?.parent

                    if (Array.isArray(data[pIndex]?.parent)) {
                        parentId = data[pIndex]?.parent[data[pIndex]?.parent.length - 1]
                    }
                    if (typeof parentId == 'object') {
                        parentId = parentId?._id
                    }

                    if (parentId == data[index]._id) {

                        if (!data[index]['*children']) {
                            data[index]['*children'] = []
                        }
                        data[index]['*children'].push(data[pIndex])
                        data[pIndex]['*hasParent'] = true
                    }
                }
                // setTimeout(() => {
                this.makeChildren(data, index, (pIndex + 1), initData, cb)
                // }, 1);
            } else {
                // setTimeout(() => {
                this.makeChildren(data, (index + 1), 0, initData, cb)
                // }, 1);
            }
        }
        else {
            cb()
        }
    }

    initData = () => {
        // console.log('initData3')
        this.setState({ clonedData: null }, () => {
            let clonedData = []
            let initclonedData = []
            if (this.props.data) {
                clonedData = JSON?.parse(JSON?.stringify(this.props.data))
                initclonedData = JSON?.parse(JSON?.stringify(this.props.data))
            }

            this.makeChildren(clonedData, 0, 0, initclonedData, () => {
                if (JSON.stringify(this.props.data) == JSON.stringify(initclonedData)) {
                    this.setState({ clonedData: JSON?.parse(JSON?.stringify(clonedData)) }, () => {
                    })
                }
                // else {

                //     this.initData()
                //     return
                // }
                if (this.props.view) {
                    let view = JSON.parse(JSON.stringify(this.props.view))
                    this.setState({ view: view })
                    // if (Array.isArray(this.props.view?.settings?.groupBy) && this.props.view?.settings?.groupBy?.length > 0) {
                    let keys = this.props.view?.settings?.groupBy

                    // console.log(keys)

                    // console.log(keys)
                    if (JSON.stringify(this.props.data) == JSON.stringify(initclonedData)) {
                        this.groupBy(0, JSON?.parse(JSON?.stringify(clonedData)), keys)
                    }
                    // } else {
                    //     // this.setState({ clonedData: null })
                    // }
                }
            })
        })
    }

    groupBy = (keyIndex = 0, data = this.props.data, keys) => {
        if (keys && keys.length > 0) {
            // console.log('groupBy')
            // if (keyIndex == 0) {
            //     this.setState({ orgData: this.props.data })
            // }
            let group = {}
            let headers = this.props.headers
            if (data) {
                let key = keys[keyIndex]
                let header
                headers.forEach(element => {
                    if (key == element.key) {
                        header = element
                    }
                });
                if (Array.isArray(data)) {
                    data.forEach(element => {
                        let value = getObject(element, key)
                        if (Array.isArray(value)) {
                            value = value[value.length - 1]
                        }
                        value = String(value)
                        if (!group[value]) {
                            group[value] = { data: [], header, id: nanoid() }
                        }
                        group[value].data.push(element)
                    });
                }
                if (keyIndex != keys.length - 1) {
                    for (const [groupKey, groupValues] of Object.entries(group)) {
                        group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys) }
                    }
                }
                if (keyIndex == 0) {

                    // console.log(JSON.parse(JSON.stringify(group)))
                    // console.log('JSON.parse(JSON.stringify(group))s', JSON.parse(JSON.stringify(group)))
                    this.setState({ clonedData: JSON.parse(JSON.stringify(group)) })
                }
                return group
            }
        }
    }
    useViewSettings = (cb) => {
        // console.log('this.props.view?.settings?.customized', this.props.view?.settings?.customized)
        // console.log('*useViewSettings', this.props.view.settings)
        if (this.props.view?.settings && Object.values(this.props.view?.settings).length != 0 && this.props.view?.settings?.customized) {
            let userSettings = JSON.parse(JSON.stringify(this.props.view?.settings))
            let customized = JSON.parse(JSON.stringify(userSettings.customized))
            let page = this.props.page
            let headers = this.props.headers
            customized?.map((element, index) => {
                headers?.map((item, pIndex) => {
                    if (element.id == item.id) {
                        let prop = JSON.parse(JSON.stringify(item))
                        headers.splice(pIndex, 1)
                        // console.log('elementsssc', element)
                        // console.log('itsfalse')
                        prop.showMain = element.showMain
                        headers.splice(index, 0, prop)
                    }
                })
            })
            page.fields = headers
            this.props.setData('page', page, 'CollectionBaseAdminView')

            this.props.setData('headers', headers, 'CollectionBaseAdminView', () => {
                // console.log('ontp2')

            })
            if (cb) {
                cb()
            }
            // this.setState({ cellWidths }, () => {
            //     // this.setWidth() 
            // })
        }
        else {
            if (cb) {
                cb()
            }
            // cellWidths = this.calcCellWidths()
        }
        // this.setState({ cellWidths }, () => {
        // })
    }
    useUserSettings = () => {
        // console.log('useUserSettingschange')
        // console.log('useUserSettings', this.props.view)
        let cellWidths = this.state.cellWidths
        if (this.props.view?.settings && Object.values(this.props.view?.settings).length != 0 && this.props.view?.settings?.tableWidth && Object.values(this.props.view?.settings.tableWidth).length > 0) {
            let userSettings = JSON.parse(JSON.stringify(this.props.view?.settings))
            cellWidths = JSON.parse(JSON.stringify(userSettings.tableWidth))
            // this.setState({ cellWidths }, () => {
            //     // this.setWidth() 
            // })
        }
        else {
            cellWidths = this.calcCellWidths()
        }
        this.setState({ cellWidths }, () => {
        })
    }

    calcResize = () => {
        let cellWidths = this.calcCellWidths()
        this.setState({ cellWidths }, () => {
            this.setWidth()
        })
    }

    prepareHeader() {
        return this.props.headers
    }

    showChildren = (parent, data, level) => {
        // let condition
        // if (item['*children'] && typeof item['*children'][0] == 'object') {
        //     item['*children'].map((element) => {
        //         if (element._id == parent) {
        //             condition = true
        //         }
        //     })
        // }
        // else if (item['*children'] && typeof item['*children'][0] == 'string') {
        //     condition = item['*children'] == parent
        // }
        if (parent['*children']) {
            return (
                <div className={''}>
                    {parent['*children']?.map((item, index) => {
                        return (
                            <div className={'w-100 '} key={index}>
                                <TableRow
                                    ref={el => this[item._id ?? item.id] = el}
                                    // index={jindex}
                                    // firstRowpadding={10*level}
                                    automations={this.props.automations}
                                    page={this.props.page}
                                    data={item}
                                    applet={this.props.applet}
                                    headers={this.props.headers}
                                    key={item?._id ?? item.id}
                                    id={item?._id ?? item?.id}
                                    permissions={this.props.permissions}
                                    widths={this.state.cellWidths}
                                    scrollX={this.state.scrollX}
                                    actions={this.props.actions}
                                    settings={this.props.settings}
                                    openActionsModal={this.openActionsModal}
                                    functionsHandler={this.props.functionsHandler}
                                    actionClicked={this.actionClickedInRow}
                                    changeSelected={this.changeSelected}
                                    selectedCell={this.state.selectedCell}
                                    firstRowpadding={((level) * 15)}
                                    changeValue={this.changeValue}
                                    changeFiles={this.changeFiles}
                                    tempValue={this.props.tempValue}
                                    zIndex={0}
                                    currentRecord={this.props.currentRecord}
                                    currentRecordStage={this.props.currentRecordStage}
                                    changeRecordStage={this.props.changeRecordStage}
                                    setCurrentRecordStage={this.props.setCurrentRecordStage}
                                    colors={this.props.colors}
                                />
                                {this.showChildren(item, data, level + 1)}
                            </div>
                        )

                    })}
                </div>
            )
        }
    }

    calcCellWidths() {
        let cellWidths = {}
        // TODO: CONSIDER SETTINGS
        cellWidths['*'] = 0
        let baseWidth = 100
        let actionsWidth = 30
        let numberOfHeader = 0
        // console.log("this.props.headers",this.props.headers)
        this.props.headers.forEach(header => {
            if (header.showMain != false) {
                numberOfHeader++
            }
        })
        if (this.tableContainer) {
            let tableWidth = getBoundingClientRect(this.tableContainer).width
            tableWidth = tableWidth - actionsWidth
            if ((numberOfHeader * baseWidth) < tableWidth) {
                baseWidth = tableWidth / numberOfHeader
            }

            // console.log(tableWidth)
        }



        this.props.headers.forEach(header => {
            if (header.showMain != false) {
                cellWidths[header.key] = baseWidth // TODO: CHANGE BY TYPE
                cellWidths['*'] += baseWidth
            }
        });
        cellWidths['*actions'] = actionsWidth // TODO: CHANGE BY TYPE
        cellWidths['*'] = cellWidths['*'] + actionsWidth // TODO: CHANGE BY TYPE
        // cellWidths['*'] = cellWidths['*'] + 150


        return cellWidths
    }

    setWidth = () => {

        if (this.tableContainer) {


            this.setState({ width: this.tableContainer.getBoundingClientRect().width }, () => {
                // this.changeWidth()
                // this.calcCellWidths()
            })
        }
    }

    // tableColBuilder(col) {
    //     let finalCol = 'col-12'
    //     if (600 < this.props.width && col) {
    //         finalCol = 'col-' + col
    //     }
    //     return finalCol
    // }

    updateData = (data, cb) => {
        this.setState({ data }, () => {
            if (cb) {
                cb()
            }
            if (this.props.updateData) {
                this.props.updateData(data)
            }
        })
    }

    changeWidth = (key, width) => {
        let cellWidths = this.state.cellWidths
        cellWidths[key] = width
        cellWidths['*'] = 0
        for (const [key, value] of Object.entries(cellWidths)) {
            if (value) {
                cellWidths['*'] += value
            }
        }
        if (cellWidths['*'] < this.props.width) {
            cellWidths['*'] = this.props.width
        }
        let tempWidth = { ...cellWidths }
        // this.props.saveUserSettings(tempWidth)
        this.setState({ cellWidths, tempWidth })
    }

    tableScroll = (e, ref) => {
        let scrollLeft = e.target.scrollLeft
        // if (!this.lastTrigger || this.lastTrigger == 'table') {
        this.syncronizer('table', scrollLeft, e.timeStamp)
        // }
        // this.table.scrollTo(scrollLeft, 0)
        // this.header.scrollTo(scrollLeft, 0)
        // if (Math.abs(scrollLeft) > 10) {
        //     scrollLeft = Math.abs(scrollLeft - 5)
        // }
        // scrollLeft = Math.min(0, scrollLeft/3 - 60);
        // this.setState({ scrollX: scrollLeft })
        // if (!this.headerIsScrolling) {
        // }
        // this.tableIsScrolling = true
        // if (!this.scrollTrigger) {
        //     this.scrollTrigger = 'table'
        // }
        // if (this.scrollTrigger != 'header') {
        //     this.header.scrollTo(scrollLeft, 0)
        // }
        // if (this.scrollTrigger != "indicator") {}
        // if(this.scrollTrigger == 'table') {
        //     this.scrollTrigger = null
        // }
        // this.scrollTrigger = null
        // scrollIndicator < 0 ? (-1 * scrollIndicator) + '%' 
        // scrollIndicator > 0 ? scrollIndicator + '%' 
    }

    headerScroll = (e) => {
        // e.preventDefault()
        let scrollLeft = e.target.scrollLeft
        // if (!this.lastTrigger || this.lastTrigger == 'header') {
        // if (this.lastTriggerTime < e.timeStamp - 1000) {
        this.syncronizer('header', scrollLeft, e.timeStamp)
        // }
        // }
        // for(const [key,value] of Object.entries(e)){}
        // if(this.table.scrollLeft != scrollLeft){}
        // this.setState({ scrollX: scrollLeft })
        // this.table.scrollTo(scrollLeft, 0)
        // this.headerIsScrolling = true
        // if (!this.scrollTrigger) {
        //     this.scrollTrigger = 'header'
        // }
        // if (this.scrollTrigger == 'header') {
        //     this.table.scrollTo(scrollLeft, 0)
        // } else {
        //     this.scrollTrigger = null
        // }
    }

    scrollHandler = (e) => {
        window.addEventListener('scroll', () => {
        })
    }

    scrollMouseDown = (e) => {
        this.initWidth = getBoundingClientRect(this.scrollIndicator).width
        this.initLeft = getBoundingClientRect(this.scrollIndicator).left
        this.tableInitLeft = getBoundingClientRect(this.table).left
        this.initX = e.clientX
        // this.setState({ selectedKey: key, initX: e.clientX })
        // document.body.
        document.body.classList.add("no-user-select")
        window.addEventListener("mousemove", this.scollMouseMove)
        window.addEventListener("mouseup", this.scollMouseUp)
    }

    scollMouseMove = (e) => {
        let x = e.clientX
        let dx = x - this.initX
        // if (Math.abs(this.initX - this.initLeft) < 20) {
        //     dx = dx * -1
        // }
        // let scrollX = (this.state.scrollX ?? 0) + dx
        // if (scrollX < 0) {
        //     scrollX = 0
        // }
        // if (scrollX > (this.state.cellWidths['*'] - this.props.width)) {
        //     scrollX = this.state.cellWidths['*'] - this.props.width
        // }
        let scrollIndicator = (this.initLeft - this.tableInitLeft) + dx//scrollX * 100
        if ((scrollIndicator + this.initWidth) > this.props.width) {
            scrollIndicator = this.props.width - this.initWidth
        }
        if (scrollIndicator <= 0) {
            scrollIndicator = 0//this.props.width - this.initWidth
        }
        let scrollChange = (this.state.cellWidths['*'] / this.props.width) * scrollIndicator
        this.syncronizer('indicator', scrollChange)
        // this.scrollTheIndicator(scrollChange)
        // if (!this.scrollTrigger) {
        //     this.scrollTrigger = 'indicator'
        // this.table.scrollTo(scrollChange, 0)
        // } else {
        //     this.scrollTrigger = null
        // }
        // let isRTL = false
        // if (document.body.classList.contains('rtl')) {
        //     isRTL = true
        // }
        // this.scrollIndicator.style.transition = 'none'
        // if (this.scrollIndicator) {
        //     if (!isRTL) {
        //         this.scrollIndicator.style.marginLeft = scrollIndicator + 'px'
        //         this.scrollIndicator.style.marginRight = 'auto'
        //     }
        //     else {
        //         this.scrollIndicator.style.marginRight = (-1 * scrollIndicator) + 'px'
        //         this.scrollIndicator.style.marginLeft = 'auto'
        //     }
        // }
        // this.setState({ scrollX })
        // this.scrollTrigger = 'indicator'
        // this.table.scrollTo(scrollX, 0)
        // if (newWidth >= 100) {
        // this.props.changeWidth(scrollX)
        // }
    }

    lastTrigger = null
    lastTriggerTime = null

    syncronizer(trigger, scrollLeft, timeStamp) {
        if (!this.lastTrigger) {
            this.lastTrigger = trigger
            this.lastTriggerTime = timeStamp
            //new Date().getTime()
        } else {
            if (this.lastTrigger != trigger) {
                if (timeStamp && timeStamp > this.lastTriggerTime + 100) {
                    this.lastTrigger = trigger
                    this.lastTriggerTime = timeStamp
                } else {
                    if (!timeStamp) {
                        this.lastTrigger = trigger
                    }
                }
            } else {
                this.lastTriggerTime = timeStamp
            }
            // if (this.lastTriggerTime && (this.lastTriggerTime < (new Date().getTime() - 1000))) {
            //     this.lastTrigger = trigger
            //     this.lastTriggerTime = new Date().getTime()
            // }
        }
        // this.lastTriggerTime = timeStamp
        if (this.lastTrigger != 'header') {
            this.header.scrollTo(scrollLeft, 0)
            // this.header.scrollLeft = scrollLeft
        }
        if (this.lastTrigger != 'table') {
            if (this.table) {
                this.table.scrollTo(scrollLeft, 0)
            }
            // this.header.offsetLeft = scrollLeft
        }
        // if (trigger == this.lastTrigger) {
        this.scrollTheIndicator(trigger, scrollLeft)
        // }
        // this.lastTrigger = null
    }

    scrollTheIndicator = (trigger, scrollLeft) => {
        let scrollIndicator = scrollLeft / this.state.cellWidths['*'] * 100
        let isRTL = false
        if (document.body.classList.contains('rtl')) {
            isRTL = true
        }
        if (this.scrollIndicator) {
            this.scrollIndicator.style.transition = 'none'
            if (!isRTL) {
                this.scrollIndicator.style.marginLeft = scrollIndicator + '%'
                this.scrollIndicator.style.marginRight = 'auto'
            }
            else {
                this.scrollIndicator.style.marginRight = (-1 * scrollIndicator) + '%'
                this.scrollIndicator.style.marginLeft = 'auto'
            }
        }
    }

    scollMouseUp = (e) => {
        document.body.classList.remove("no-user-select")
        this.lastTrigger = null
        window.removeEventListener("mousemove", this.scollMouseMove)
        window.removeEventListener("mouseup", this.scollMouseUp)
    }

    openActionsModal = (rowData, index) => {
        this.selectedRowData = rowData
        this.selectedRowIndex = index
        // this.actionsModal.showModal()
    }

    actionClickedInRow = (prop, rowData, index, extra) => {
        this.selectedRowData = rowData
        this.selectedRowIndex = index

        // console.log(prop)
        // console.log(rowData)

        this.actionClicked(prop, extra)
    }

    actionClicked = (prop, extra) => {
        if (typeof prop.function == 'function') {
            prop.function(this.selectedRowData, this.selectedRowIndex)
        } else {
            if (this.props[prop.function]) {
                this.props[prop.function](this.selectedRowData, this.selectedRowIndex, prop)
            } else {
                let myExtra = extra

                if (typeof extra == 'object') {
                    myExtra = extra ? { ...extra } : {}
                    myExtra.index = this.selectedRowIndex
                }

                this.props.functionsHandler('frame', prop.function, this.selectedRowData, myExtra)
            }
        }
        // this.actionsModal.hideModal()
        // prop.function(this.selectedRowData, this.selectedRowIndex)
        // this.actionsModal.hideModal()
    }

    changeCollapse = (id) => {
        let collapses = this.state.collapses
        collapses[id] = collapses[id] ? false : true
        this.setState({ collapses })
    }

    changeSelected = (mid, key, initData) => {
        let id = mid
        if (id && typeof id == 'object') {
            id = id._id
        }
        // let selectedCell = null
        let headerKey = `${id}-${key}`
        let selectedCell = this.state.selectedCell
        let last = selectedCell['*last'] ? JSON.parse(JSON.stringify(selectedCell['*last'])) : null
        // if (selectedCell[headerKey]) {
        // if (id) {
        if (last) {
            last.newData = (selectedCell[last.fullId]?.newData ? JSON.parse(JSON.stringify(selectedCell[last.fullId]?.newData)) : null) ?? initData
            delete selectedCell[last.fullId]
        }
        // selectedCell[headerKey] = { id, key, initData, newData: initData }
        // }
        selectedCell[headerKey] = { id, key, initData, newData: initData }
        selectedCell["*last"] = { id, key, initData, newData: initData, fullId: `${id}-${key}` }
        // selectedCell = { id, key, initData, newData: initData }
        // }
        this.setState({ selectedCell }, () => {
            if (this.props.updateRecord && last) {
                this.props.updateRecord(last, last?.fullId)
            }
        })
    }

    changeValue = (key, value, extra) => {
        let selectedCell = this.state.selectedCell
        if (selectedCell[`${extra._id}-${key}`]) {
            selectedCell[`${extra._id}-${key}`].newData = value
            this.setState({ selectedCell })
            if (this.props.changeValue) {
                this.props.changeValue(selectedCell)
            }
        }
    }

    changeFiles = (value, key, extra) => {
        let selectedCell = this.state.selectedCell
        if (selectedCell[`${extra._id}-${key}`]['**files'] == null) {
            selectedCell[`${extra._id}-${key}`]['**files'] = {}
        }
        if (value) {
            value.formType = ''
        }
        this.state.headers.forEach(header => {
            if (value && header.key == key) {
                value.formType = header.type
                // value.single = header.information?.single
            }
        });
        selectedCell[`${extra._id}-${key}`]['**files'] = value
        this.setState({ selectedCell })
    }

    renderBody(data, header, value, index) {
        // console.log('dataTable', data)
        if (Array.isArray(data)) {
            let RowContainerComponent = "div"
            if (this.props.settings?.isSortable) {
                RowContainerComponent = DraggableList
            }
            return (
                <>
                    {/* {(index * 10)} */}
                    <div className='a'>
                        <div onScroll={(e) => { this.scrollTrigger = 'table'; this.tableScroll(e) }} ref={el => this.table = el} className="w-100 h-100 no-scrollbar test" style={{ overflow: 'auto' }}>
                            {/* <div ref={el => this.header = el} className="text-center w-100 no-scrollbar" style={{ overflow: 'auto', zIndex: 4, position: 'sticky', top: 47 }}>
                            <div style={{}}>
                            <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} />
                            </div>
                            </div> */}
                            {/* <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} scrollX={this.state.scrollX} /> */}
                            <div className="tableBody"
                            //  style={{ width: this.state.cellWidths['*'] }}
                            >
                                {/* <RowContainerComponent dragStarted={this.dragStarted} dragOver={this.dragOver} data={this.props.data} updateData={this.updateData} width={this.props.width}> */}
                                <RowContainerComponent dragstarted={this.dragStarted} dragover={this.dragOver} data={this.props.data} updatedata={RowContainerComponent != 'div' ? this.updateData : null} width={this.props.width}>
                                    {data && data.map((prop, jindex) => {
                                        if (!prop['*hasParent'])
                                            return (
                                                <React.Fragment key={prop._id ?? prop.id}>
                                                    {/* {(!prop.parent || prop?.parent?.length == 0) && ( */}
                                                    <>
                                                        <div className="" style={{ overflow: "auto", width: '100%', position: "absolute", inset: 0, minHeight: "100%", pointerEvents: "none" }}>
                                                            <div className="" onScroll={(e) => this.scrollHandler(e)} style={{ zIndex: 1, position: "absolute", inset: 0, minHeight: "100%", width: this.state.cellWidths, pointerEvents: "none" }}></div>
                                                        </div>
                                                        <TableRow
                                                            ref={el => this[prop._id ?? prop.id] = el}
                                                            index={jindex}
                                                            data={prop}
                                                            automations={this.props.automations}
                                                            page={this.props.page}
                                                            applet={this.props.applet}
                                                            headers={this.props.headers}
                                                            key={prop._id ?? prop.id}
                                                            id={prop?._id ?? prop?.id}
                                                            widths={this.state.cellWidths}
                                                            scrollX={this.state.scrollX}
                                                            actions={this.props.actions}
                                                            settings={this.props.settings}
                                                            openActionsModal={this.openActionsModal}
                                                            functionsHandler={this.props.functionsHandler}
                                                            actionClicked={this.actionClickedInRow}
                                                            changeSelected={this.changeSelected}
                                                            selectedCell={this.state.selectedCell}
                                                            firstRowpadding={((index + 1) * 5)}
                                                            changeValue={this.changeValue}
                                                            changeFiles={this.changeFiles}
                                                            tempValue={this.props.tempValue}
                                                            zIndex={0}
                                                            currentRecord={this.props.currentRecord}
                                                            currentRecordStage={this.props.currentRecordStage}
                                                            changeRecordStage={this.props.changeRecordStage}
                                                            setCurrentRecordStage={this.props.setCurrentRecordStage}
                                                            colors={this.props.colors}
                                                            permissions={this.props.permissions}
                                                        // liveChange={this.props.liveChange}
                                                        />
                                                        {this.showChildren(prop, data, 1)}
                                                    </>
                                                    {/* )} */}
                                                </React.Fragment>
                                            )
                                    })}
                                    {/* FOR FIXED FIELDS */}
                                    <div className='my-2 scroll-no-scroll d-none' style={{ position: "absolute", top: "0", boxShadow: ' 3px 0px 10px -10px #000', backgroundColor: "#fff" }}>
                                        <div className=' ' style={{ zIndex: 1, }}>
                                            {/* <div className='px-3 tableHeaderContainer' style={{ zIndex: 5, position: 'sticky', top: this.props.top != null ? this.props.top : 0 }}> */}
                                            {/* <div onScrollCapture={(e) => this.headerScroll(e)} ref={el => this.header = el} className="text-center w-100 " style={{  }}> */}
                                            {/* <div style={{}}> */}
                                            {/* {console.log(this.props.groupByField)} */}
                                            <TableHead groupByField={this.props.groupByField} handleCopy={this.props.handleCopy} duplicateField={this.props.duplicateField} insertField={this.props.insertField} sortFieldRecord={this.props.sortFieldRecord} setCurrentHead={this.props.setCurrentHead} currentHead={this.props.currentHead} fieldOptions={this.props.fieldOptions} hideHeaderField={this.props.hideHeaderField} deleteHeaderField={this.props.deleteHeaderField} userSettings={this.props.userSettings} maxIndex={0} headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} actions={this.props.actions} settings={this.props.settings} tempWidth={this.state.tempWidth} saveUserSettings={this.props.saveUserSettings} functionsHandler={this.props.functionsHandler} />
                                            {/* </div> */}
                                            {/* </div> */}
                                        </div>
                                        {data && data.map((prop, jindex) => {
                                            // { this.showChildren(prop._id, data, 0) }
                                            return (
                                                <TableRow
                                                    ref={el => this[prop.id] = el}
                                                    index={jindex}
                                                    data={prop}
                                                    page={this.props.page}
                                                    automations={this.props.automations}
                                                    applet={this.props.applet}
                                                    maxIndex={0}
                                                    permissions={this.props.permissions}
                                                    headers={this.props.headers}
                                                    key={prop._id ?? prop.id}
                                                    id={prop._id ?? prop.id}
                                                    widths={this.state.cellWidths}
                                                    pointer={'none'}
                                                    scrollX={this.state.scrollX}
                                                    actions={this.props.actions}
                                                    settings={this.props.settings}
                                                    openActionsModal={this.openActionsModal}
                                                    functionsHandler={this.props.functionsHandler}
                                                    actionClicked={this.actionClickedInRow}
                                                    firstRowpadding={(index * 5)}
                                                    changeValue={this.changeValue}
                                                    tempValue={this.props.tempValue}
                                                    zIndex={0}
                                                    currentRecord={this.props.currentRecord}
                                                    currentRecordStage={this.props.currentRecordStage}
                                                    changeRecordStage={this.props.changeRecordStage}
                                                    setCurrentRecordStage={this.props.setCurrentRecordStage}
                                                    colors={this.props.colors}
                                                // liveChange={this.props.liveChange}
                                                />
                                            )
                                        })}
                                    </div>

                                    {(!this.props.data || this.props.data.length == 0) && !this.props.isLoading && (
                                        <div className='text-small py-4 text-center'>
                                            <p className='opacity-5'>{translate("found-nothing")}</p>
                                        </div>
                                    )}
                                </RowContainerComponent>
                            </div>
                        </div>
                    </div>
                </>
            )
        } else {
            if (data) {

                let dataArray = Object.entries(data)
                return (
                    <div >
                        {Array.isArray(dataArray) && dataArray?.length > 0 && dataArray.map(([key, value], cindex) => {
                            return (
                                <div  >
                                    <div>
                                        {value.header && index == 0 && (
                                            <div onClick={() => this.changeCollapse(value.id)} className='' style={{ cursor: 'pointer', borderBottom: '1px solid #EEEDEC50', backgroundColor: 'rgb(248,248,249)', position: 'sticky', zIndex: 1, top: this.props.top != null ? (this.props.top + 36) : 36 }}>
                                                <div className='px-2 flexcb' style={{ paddingTop: 7, paddingBottom: 6, backgroundColor: '#fff', borderRadius: '10px 10px 0px 0px', }}>
                                                    <div className='flexc'>
                                                        {/* <div style={{ width: 5, borderRadius: 20, height: 18, background: '#aaa', }}></div> */}
                                                        <div className='px-2 flexcc'>
                                                            <img className={'opacity-2 transition-all ' + (this.state.collapses[value.id] ? 'rotate-270' : '')} src='/assets/icons/priority.svg' height={10} />
                                                        </div>
                                                        <p className='text-small text-semibold  ' style={{ color: '#555', padding: '0px 4px' }}>{checkTranslation(key)}</p>
                                                    </div>
                                                    <p className='text-smaller text-semibold  br-20 px-2 py-1' style={{ backgroundColor: '#f2f2f2', color: '#999' }}>{checkTranslation(value.header?.information?.label)}</p>
                                                </div>
                                            </div>
                                        )}
                                        {value.header && index > 0 && (
                                            <div onClick={() => this.changeCollapse(value.id)} className='mb-0' style={{ cursor: 'pointer', paddingLeft: (index) * 10, borderBottom: '1px solid rgba(238, 237, 236, 0.5)', backgroundColor: '' }}>
                                                <div className='px-2 flexcb' style={{ paddingTop: 7, paddingBottom: 6, }}>
                                                    <div className='flexcc'>
                                                        {/* <div style={{ width: 5, borderRadius: 20, height: 18, background: '#aaa', }}></div> */}
                                                        <div className='px-2 flexcc'>
                                                            <img className={'opacity-2 transition-all ' + (this.state.collapses[value.id] ? 'rotate-270' : '')} src='/assets/icons/priority.svg' height={10} />
                                                        </div>
                                                        <p className='text-small text-semibold  ' style={{ color: '#999', padding: '0px 4px' }}>{checkTranslation(key)}</p>
                                                    </div>
                                                    <p className='text-smaller text-semibold  br-20 px-2 py-1' style={{ backgroundColor: '#f2f2f2', color: '#999' }}>{checkTranslation(value.header?.information?.label)}</p>
                                                    {/* <div className='px-2 flexcc'>
                                                        <img className='opacity-5' src='/assets/icons/down-arrow.svg' height={14} />
                                                    </div> */}
                                                </div>
                                            </div>
                                        )}
                                        <Collapsible open={!this.state.collapses[value.id]}>
                                            {this.renderBody(value.data, value.header, key, index + 1)}
                                        </Collapsible>
                                    </div>
                                    {index == 0 && (
                                        <div>
                                            <div className='w-100' style={{ height: 40, background: 'rgb(248,248,249)' }}>
                                                <div style={{ backgroundColor: '#fff', height: 10, borderRadius: '0px 0px 10px 10px' }}>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        })}

                        {(!dataArray || dataArray?.length == 0) && (
                            <div className='text-small py-4 text-center'>
                                <p className='opacity-5'>{translate("found-nothing")}</p>
                            </div>
                        )}
                    </div>
                )
                // for (const [key, value] of Object.entries(data)) {}
            }
        }
    }

    render() {
        // var shadowElement = this.state.shadowElement
        if (this.state.show) {
            // let scrollIndicator = this.state.scrollX / this.state.cellWidths['*'] * 100
            return (
                <section ref={el => this.tableContainer = el} className={" w-100 table defaultTable h-100 " + (this.state.broswer)} style={{}} >
                    {/* <div className=' tableHeaderContainer' style={{ zIndex: 2, top: this.props.top != null ? this.props.top : 0 }}> */}
                    <div className='px-0 tableHeaderContainer' style={{ top: this.props.top != null ? this.props.top : 0 }}>
                        {/* <div style={{}}> */}
                        <div onScrollCapture={(e) => this.headerScroll(e)} ref={el => this.header = el} className="text-center w-100 no-scrollbar" style={{ overflow: 'auto', }}>
                            <TableHead groupByField={this.props.groupByField} handleCopy={this.props.handleCopy} insertField={this.props.insertField} duplicateField={this.props.duplicateField} sortFieldRecord={this.props.sortFieldRecord} setCurrentHead={this.props.setCurrentHead} currentHead={this.props.currentHead} fieldOptions={this.props.fieldOptions} hideHeaderField={this.props.hideHeaderField} deleteHeaderField={this.props.deleteHeaderField} userSettings={this.props.userSettings} headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} actions={this.props.actions} settings={this.props.settings} tempWidth={this.state.tempWidth} saveUserSettings={this.props.saveUserSettings} functionsHandler={this.props.functionsHandler} />
                        </div>
                        {/* </div> */}
                    </div>
                    {this.props.isLoading && (
                        <div className="flexcc mt-4 mb-3">
                            <Loader
                                type={"ThreeDots"}
                                color={"#789"}
                                height={20}
                                width={50}
                            />
                        </div>
                    )}
                    {/* {!this.props.isLoading && this.props.data?.length == 0 && (
                        <div className="flexcc mt-4 mb-3 w-100" style={{height:50}}>
                            <p className="description-text text-small">{translate('foundNothing').toUpperCase()}</p>
                        </div>
                    )} */}
                    <div className='' style={{}}>
                        {/* <div className='' style={{ borderBottom: '1px solid #EEEDEC50', backgroundColor: 'rgb(248,248,249)', position: 'sticky', zIndex: 2, top: this.props.top != null ? (this.props.top + 32) : 32 }}>
                            <div className='px-2 flexcb' style={{ paddingTop: 10, paddingBottom: 6, backgroundColor: '#fff', borderRadius: '20px 20px 0px 0px', }}>
                                <div className='flexc'>
                                    <p className='text-normal text-bold  ' style={{color:'#ee5050', padding: '0px 10px' }}>High</p>
                                    <p className='text-smaller text-semibold color-gray-2 br-4 px-2 py-1' style={{ backgroundColor: '#eee' }}>Priority</p>
                                </div>
                                <div className='px-2 flexcc'>
                                    <img className='opacity-5' src='/assets/icons/down-arrow.svg' height={14} />
                                </div>
                            </div>
                        </div> */}
                        {/* <div className='mb-0' style={{ borderBottom: '1px solid #EEEDEC50', backgroundColor: 'rgb(248,248,249)' }}>
                            <div className='px-3 flexcb' style={{ paddingTop: 10, paddingBottom: 6, }}>
                                <div className='flexcc'>
                                    <p className='text-small text-semibold  ' style={{ padding: '0px 10px' }}>Username</p>
                                    <p className='text-smaller text-semibold color-gray-2 br-4 px-2 py-1' style={{ backgroundColor: '#eee' }}>Asignee</p>
                                </div>
                                <div className='px-2 flexcc'>
                                    <img className='opacity-5' src='/assets/icons/down-arrow.svg' height={14} />
                                </div>
                            </div>
                        </div> */}
                        {/* {console.log('this.state.clonedData1', this.state.clonedData)}
                        {console.log('this.props.data1', this.props.data)} */}
                        {this.renderBody((this.state.clonedData ?? this.props.data), null, null, 0)}

                    </div>
                    {/* <div className="text-center p-2" style={{ backgroundColor: '#ee5050', position: 'sticky', bottom: 10 }}>
                        <TableHead headers={this.state.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} scrollX={this.state.scrollX} />
                    </div> */}
                    {this.state.cellWidths['*'] > this.props.width && (
                        <div className="tableScroll mt-1" >
                            <div ref={el => this.scrollIndicator = el} className="scrollIndicator" onMouseDown={e => this.scrollMouseDown(e)} style={{ width: (this.props.width / this.state.cellWidths['*']) * 100 + '%', }}>
                            </div>
                        </div>
                    )}
                    {/* <Modal ref={el => this.actionsModal = el} maxWidth={300}>
                        <div className="modal-body py-4 px-4 text-center " style={{ borderRadius: 12 }}>
                            <p className="text-bold text-uppercase mb-0">{translate("Choose Action")}</p>
                            <p className="text-smaller  mb-3 text-description">{translate("List of available actions")}</p>
                            {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                                return (
                                    <div key={index} className="mb-1 w-100">
                                        <button onClick={() => this.actionClicked(prop, index)} className="w-100" style={{ backgroundColor: prop.color ? prop.color : '#007aff15', borderRadius: 8, padding: '10px 20px' }}>
                                            <p className="text-bold text-uppercase text-normal" style={{ color: '#fff' }}>{checkTranslation(prop.label)}</p>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                    </Modal> */}
                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default TableViewer;